<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Total Main Con Equipment (By Type)
      <div style="color: #6CF;font-size: 40px;display: inline-block;position: absolute;right: 5%;top: 5%">Total
        Equipment:{{ total }}
      </div>
    </h1>
    <div v-if="dataNotNull" key="1" class="equipmentDiv"
         style="width: 100%; height: 793px; position: absolute; bottom: 0">

      <div class="container1" style="height: 100%;"></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
    <div class="equip_detail" v-show="showflag" id="equip_detail">
      <p style="margin-top: 20px">Equipment Certificate</p>
      <div class="close_img" @click="detailClose"></div>
      <div style="margin-top:40px;background-color: #fff">
        <p>Total Equipment:{{ total }}</p>
        <el-row :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple" style="text-align: left;font-size:40px;margin-left: 10px">
              Type
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">Cnt</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px">
          <el-col :span="16">
            <div class="grid-content bg-purple" style="text-align: left;font-size:36px;margin-left: 10px">
              Expired
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple" style="font-size:36px;margin-left: 10px">{{ expired }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px">
          <el-col :span="16">
            <div class="grid-content bg-purple" style="text-align: left;font-size:36px;margin-left: 10px">
              Expiring
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple" style="font-size:36px;margin-left: 10px">{{ expiring }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  name: "equipment",
  props: ['project_id'],

  data() {
    return {
      my_project_id: this.project_id,
      legendArr: [],
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "equipment",
      dataNotNull: true,
      total: 0,
      showflag: false,
      expired: 0,
      expiring: 0
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  methods: {
    getData() {
      var that = this
      let postData = {
        project_id: this.my_project_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token')
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjEquipType", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          this.dataNotNull = true
          var legends = []
          var equipments = []
          var result = resp.data.result;
          var data = this.analysisResult(result)
          this.myChart.setOption({
            yAxis: {
              data: data.legends,
            },
            series: [
              {
                data: data.totle
              },
              {
                data: data.assists,
                label: {
                  normal: {
                    show: true,
                    color: '#6cf',
                    position: 'insideRight',
                    formatter: function (params) {
                      return parseInt(params.value) - parseInt(data.assist);
                    }
                  }
                },
              },
              {
                data: data.equipments
              }
            ]
          })
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    },
    getExpData() {
      var that = this
      let postData = {
        cms_projid: this.my_project_id,
        host: window.localStorage.getItem("token_key"),
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsDBServer + "CMSGetExpiredCnt", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          let result = resp.data.result
          that.expired = result[0].expired_count
          that.expiring = result[0].expiring_count
        }
      }).catch(error => {
        alert(error)
      })
    },
    detailClose() {
      this.showflag = false
    },
    dragFunc(id) {
      var Drag = document.getElementById(id);
      Drag.onmousedown = function (event) {
        var ev = event || window.event;
        event.stopPropagation();
        var disX = ev.clientX - Drag.offsetLeft;
        var disY = ev.clientY - Drag.offsetTop;
        document.onmousemove = function (event) {
          var ev = event || window.event;
          Drag.style.left = ev.clientX - disX + "px";
          Drag.style.top = ev.clientY - disY + "px";
          Drag.style.cursor = "move";
        };
      };
      Drag.onmouseup = function () {
        document.onmousemove = null;
        this.style.cursor = "default";
      }
    },
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    analysisResult(result) {
      var legends = []
      var equipments = []
      var assists = []
      var totle = []
      var total = 0
      var assist = 0

      for (var i in result) {
        var type = result[i].device_type_en
        var count = result[i].count
        if (type.length > 13) {
          type = type.substring(0, 13) + '\n' + type.substring(13, type.length)
        }
        legends.push(type)
        equipments.push({name: type, value: count})
        total += parseInt(count)
      }
      this.total = total
      total *= 0.7
      assist = total / 8
      for (var i in result) {
        var type = result[i].device_type_en
        var count = parseInt(result[i].count) + assist
        assists.push({name: type.substring(0, 18), value: count})
        totle.push({name: type.substring(0, 18), value: total})
      }
      return {legends: legends, equipments: equipments, assists: assists, totle: totle, assist: assist}
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.myChart = echarts.init(document.querySelector('.equipmentDiv .container1'))
    this.myChart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        formatter: function (params) {
          return params[1].name + ':  ' + Math.round(params[2].value * 70 / params[0].value) + '%';
        },
        textStyle: {
          fontSize: '40'
        }
      },
      grid: {
        left: 430
      },
      xAxis: {
        type: 'value',
        show: false,
        axisLabel: {
          formatter: '{value}'
        },
      },
      yAxis: {
        type: 'category',
        inverse: true,
        data: [],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#6CF'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          margin: 10,
          align: 'right',
          show: true,
          textStyle: {
            color: '#FFF',
            fontSize: 20
          }
        },
        splitLine: {
          show: false
        }
      },
      series: [
        {
          name: '总计',
          type: 'bar',
          barGap: '-100%',
          barWidth: '60%',
          label: {
            normal: {
              show: false,
              color: '#6cf',
              position: 'insideRight',
            }
          },
          itemStyle: {
            normal: {
              color: '#00000000',
              borderColor: '#999',
              borderWidth: '0',
            }
          },
          data: []
        },
        {
          name: '总计',
          type: 'bar',
          barGap: '-100%',
          barWidth: '60%',
          label: {
            normal: {
              show: true,
              color: '#6cf',
              position: 'insideRight',
              formatter: '{c}',
              textStyle: {
                fontSize: 20
              }
            }
          },
          itemStyle: {
            normal: {
              color: '#00000000',
            }
          },
          data: []
        },
        {
          name: '总计',
          type: 'bar',
          barWidth: '60%',
          data: [],
          label: {
            normal: {
              show: false,
              formatter: '{b}'
            }
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return that.color[params.dataIndex]
              },
            }
          },
        }
      ]
    })
    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });


    this.myChart.on('click', function (param) {
      that.showflag = true
    });
    this.getData()
    this.getExpData()
    this.dragFunc("equip_detail")
  }

}
</script>

<style lang="stylus" scoped>
.equip_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 40%;
  height: 80%;
  left: 30%;
  top: 12%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
}

.close_img {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/equipment.vue